import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EventLogs } from 'src/app/models/eventLog.model';
import { Plant } from 'src/app/models/plant.model';
import { Train } from 'src/app/models/train.model';
import { EventlogsService } from 'src/app/services/eventlogs/eventlogs.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { TrainService } from 'src/app/services/trains/trains.service';

@Component({
  selector: 'app-add-eventlogs',
  templateUrl: './add-eventlogs.component.html',
  styleUrls: ['./add-eventlogs.component.scss'],
})
export class AddEventlogsComponent {
  constructor(
    private router: Router,
    private plantsService: PlantsService,
    private trainService: TrainService,
    private eventlogsService: EventlogsService,
    private toastr : ToastrService
  ) {}

  addEventLogsRequest: EventLogs = new EventLogs();
  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  plants: Plant[] = [];
  trains: Train[] = [];
  dateNow: Date = new Date();
  SelectedId: string;

  loggedInUserRole:string;
  loggedinUserId:string;
  plantAndUserId:string;

  getSelectedId(e) {
   
    this.SelectedId = e.target.value;
    if(this.loggedInUserRole =='Standard User')
      {
    this.plantAndUserId = this.SelectedId + 'Z' + this.loggedinUserId;
    this.trainService.GetAccessibleTrainListByPlantId(this.plantAndUserId)
      
      .subscribe(
        (response: Train[]) => {
          this.trains = response;
        },
        (error: any) => {
          console.log('error list');
        }
      );
  }
  else
  {
    this.trainService.getTrainByPlantId(this.SelectedId).subscribe(
      (response: Train[]) => {
        this.trains = response;
      },

      (error: any) => {
        console.log('error list');
      }
    );
  }
}

  ngOnInit(): void {
    const dateNowISO = this.dateNow.toISOString();
    this.addEventLogsRequest.Datetime = dateNowISO;

    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.loggedInUserRole = loggedInuserRole.role;
      this.loggedinUserId = loggedInuserRole.userId;
      this.plantsService.getPlantsByUserId(loggedInuserRole.userId)
      .subscribe({
        next: (plants)=>{
          this.plants = plants;
        },
      })
      
    }
    else
    {
    this.plantsService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
      },
      error: (response) => {
        console.log(response);
      },
    });
  }
   // get trainid from breadcrumbs
     this.plantsService.selectedTrain$
      .subscribe(trainId => {
        if (trainId) {
         this.addEventLogsRequest.TrainId = trainId;
        }
      });
  }
  addEventLogs() {
    const dateNowISO = this.dateNow.toISOString();

    this.addEventLogsRequest.CreatedAt = dateNowISO;
    this.addEventLogsRequest.UpdatedAt = dateNowISO;

    this.eventlogsService.addEventLogs(this.addEventLogsRequest).subscribe({
      next: (model) => {
        this.toastr.success('Event created successfully.', 'Information')
        this.router.navigate(['/eventlogs']);
      },
    });
  }
}
